import { useTranslation } from 'react-i18next';

const FamilyBuildingJourney = ({ handleSubmit, prevStep, handleChange, formData, isLastStep, nextStep,isSubmitting,error,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();
  // Check if any option is selected to enable the button

  return (
    <>
      <div className="step-section">
        <h3 className="page-heading-secondary-black-500 mb-5">{t('yourjourney')}</h3>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="journeyStage"
            id="journeyStage1"
            value={t('gettingstarted')}
            checked={formData.journeyStage === t('gettingstarted')}
            onChange={handleChange}
          />
          <label for="journeyStage1" className="multistep-form-radio-checkbox-label">{t('gettingstarted')}</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="journeyStage"
            id="journeyStage2"
            value={t('troubleconceiving')}
            checked={formData.journeyStage === t('troubleconceiving')}
            onChange={handleChange}
          />
          <label for="journeyStage2" className="multistep-form-radio-checkbox-label">{t('troubleconceiving')}</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="journeyStage"
            id="journeyStage3"
            value={t('startingtreatment')}
            checked={formData.journeyStage === t('startingtreatment')}
            onChange={handleChange}
          />
          <label for="journeyStage3" className="multistep-form-radio-checkbox-label">{t('startingtreatment')}</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="journeyStage"
            id="journeyStage4"
            value={t('treatmentbefore')}
            checked={formData.journeyStage === t('treatmentbefore')}
            onChange={handleChange}
          />
          <label for="journeyStage4" className="multistep-form-radio-checkbox-label">{t('treatmentbefore')}</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="journeyStage"
            id="journeyStage5"
            value={t('perthhood')}
            checked={formData.journeyStage === t('perthhood')}
            onChange={handleChange}
          />
          <label for="journeyStage5" className="multistep-form-radio-checkbox-label">{t('perthhood')}</label>
        </div>
        {error && <p className="text-danger">{error}</p>}
        {/* Navigation Buttons */}
        <div className="mt-5">
  {isHighmarkPortal ? (
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={prevStep}></button>
      <span className="me-3">{step} of {totalSteps}</span>
      {isLastStep ? (
        <button className="next-btn" onClick={handleSubmit} disabled={isSubmitting}></button>
      ) : (
        <button className="next-btn" onClick={nextStep}></button>
      )}
    </div>
  ) : (
    <>
      <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
        {t('back')}
      </button>
      {isLastStep && (
        <button
          className="win-btn-primary mobile-view mb-3"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {t('healthprofile')}
        </button>
      )}
    </>
  )}
</div>

      </div>
    </>
  );
};

export default FamilyBuildingJourney;
